import { AutogenModelZoneSuperRegion, AutogenRowZoneSuperRegion } from "./autogen/AutogenModelZoneSuperRegion";

export class ModelZoneSuperRegion extends AutogenModelZoneSuperRegion<RowZoneSuperRegion> {
	constructor() {
		super(RowZoneSuperRegion);
	}
}

export class RowZoneSuperRegion extends AutogenRowZoneSuperRegion {
}